import { render } from "./UniqueImagePicker.vue?vue&type=template&id=5b40a62c"
import script from "./UniqueImagePicker.vue?vue&type=script&lang=js"
export * from "./UniqueImagePicker.vue?vue&type=script&lang=js"

import exportComponent from "/chi/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__